import { createSlice } from '@reduxjs/toolkit'

type PollingState = {
  intervalMap: { [thunkId: string]: NodeJS.Timeout }
}

const initialState: PollingState = {
  intervalMap: {},
}

export const pollingSlice = createSlice({
  name: 'polling',
  initialState,
  reducers: {
    setPollingInterval(
      state,
      action: { payload: { thunkId: string; intervalId: NodeJS.Timeout } },
    ) {
      state.intervalMap[action.payload.thunkId] = action.payload.intervalId
    },
    clearPollingInterval(state, action: { payload: string }) {
      console.log('clearing polling interval', action.payload)
      clearInterval(state.intervalMap[action.payload])
      delete state.intervalMap[action.payload]
    },
  },
})

export const PollingActions = {
  ...pollingSlice.actions,
}

export const PollingReducer = pollingSlice.reducer
